export default "__VITE_ASSET__BOv1JgIr__"